import React from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { customContainer } from '@utils/twin-macro';

import Post from '@components/blog/post';
import Recommended from '@components/blog/recommended';

const Wrapper = styled.div`
  ${customContainer}
  ${tw`
    flex flex-wrap w-320 px-10
    sm:w-460
    md:w-auto
    lg:px-0
  `}
`;

const PostsWrapper = tw.div`w-full lg:w-2/3`;

const Posts = ({ posts, locale, noRecommended }) => (
  <Wrapper>
    <PostsWrapper>
      {posts.map((post) => (
        <Post key={post.id} post={post} locale={locale} />
      ))}
    </PostsWrapper>
    {!noRecommended && (
      <Recommended locale={locale} />
    )}
  </Wrapper>
);

Posts.defaultProps = {
  noRecommended: false,
};

Posts.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.any,
    ),
  ).isRequired,
  locale: PropTypes.string.isRequired,
  noRecommended: PropTypes.bool,
};

export default Posts;
